import React, {Component} from 'react';
import PropTypes from 'prop-types';

import WorkflowTaskDueDate from './WorkflowTaskDueDateUpcoming';
import WorkflowTaskStatus from './WorkflowTaskStatus';
import WorkflowCategoryChip from './WorkflowCategoryChip';


class UpcomingTask extends Component {
  static propTypes = {
    task: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render(){
    const {task} = this.props;
    const content = task.content;
    return (
      <li className="col-md-12 d-flex flex-row list-group-item upcoming-task" style={{flex: '0 0 auto'/*IE workaround*/}} onClick={this.props.onClick}>
        <div className="task-icon p-2"><WorkflowCategoryChip category={task.category} size="md"/></div>
        <div className="task-details p-2 flex-fill">
          <div className="task-name">{content.taskName}</div>
          <div className="task-description">{content.description}</div>
          <div className="task-description d-flex flex-wrap justify-content-between">
            <WorkflowTaskDueDate id={task._id} canBePastDue={!!content.dueDate} status={content.status} due={content.dueDate} />
            <WorkflowTaskStatus status={content.status} />
          </div>
        </div>
      </li>
    );
  }
}

export default UpcomingTask;
